	function ciclo(){
	return {
		"games":[
			{
				"informs":[
					{
						"text":"A doença Covid-19 é transmitida através do contato com o vírus  SARS-CoV-2.",
						"title":"Quem está envolvido no ciclo da doença?",
						"image":"images/games/informs/ciclo/1.png",
					},
					{
						"text":"Pessoas saudáveis podem ser expostas ao vírus quando entram em contato diretamente com uma pessoa infectada.",
						"title":"Quem está envolvido no ciclo da doença?",
						"image":"images/games/informs/ciclo/1.png",
					},
					{
						"text":"A transmissão também pode ocorrer de modo indireto, isto é, quando uma pessoa saudável tocar em superfícies que foram contaminadas por pessoas doentes.",
						"title":"Quem está envolvido no ciclo da doença?",
						"image":"images/games/informs/ciclo/1.png",
					},
					{
						"text":"Pessoas contaminadas  assintomáticas  transmitem o vírus tanto quanto as que apresentam os sintomas.",
						"title":"Quem está envolvido no ciclo da doença?",
						"image":"images/games/informs/ciclo/1.png",
					},
					{
						"text":"Assim, é muito importante que todos sigam os métodos de prevenção, principalmente o uso da máscara e distanciamento.",
						"title":"Quem está envolvido no ciclo da doença?",
						"image":"images/games/informs/ciclo/1.png",
					},
					{
						"text":"Se esteve em contato com um indivíduo que apresenta sintomas da Covid-19, fique isolado até ter certeza do diagnóstico da pessoa.",
						"title":"Quem está envolvido no ciclo da doença?",
						"image":"images/games/informs/ciclo/1.png",
					},
					{
						"text":"Se confirmado e a pessoa for considerada doente, a ANVISA recomenda  que você continue isolado por 10 dias, pelo menos, usando máscaras o tempo todo.",
						"title":"Quem está envolvido no ciclo da doença?",
						"image":"images/games/informs/ciclo/1.png",
					},
					{
						"text":"Atenção se tiver sintomas parecidos com os da gripe, febre e dores no corpo, procure um serviço médico.",
						"title":"Quem está envolvido no ciclo da doença?",
						"image":"images/games/informs/ciclo/1.png",
					}
				],
				"pathImageGame":"midias/images/games/puzzles/ciclo/1.png"
			}
		]
	};
}

export {ciclo};
